import { MeawwApi } from "../../utils/api.js";
import { setAppMessage } from "../../app-actions.js";
import { MessageTypes } from "../../app-constants/index.js";

// ---- Fetch trending bar items
function fetchTrendingBarRequest() {
  return { type: 'trendingBar.fetch.request' };
}
function fetchTrendingBarSuccess(items) {
  return { type: 'trendingBar.fetch.success', items };
}
function fetchTrendingBarFailure() {
  return { type: 'trendingBar.fetch.failure' };
}

export function fetchTrendingBar() {
  return (dispatch, getState) => {
    dispatch(fetchTrendingBarRequest());
    const { activeDomain } = getState().login.user;
    return MeawwApi()
      .auth()
      .then(api => {
        return api.get(`/lp/${activeDomain}/trending-bar`,
          (error, data) => {
            if (error) {
              dispatch(setAppMessage(error.message, { type: MessageTypes.ERROR }));
              dispatch(fetchTrendingBarFailure());
              return Promise.reject(error);
            }
            dispatch(fetchTrendingBarSuccess(data.result));
            return Promise.resolve(data);
          });
      });
  };
}

// ---- Submit (create or update)
export function submitTrendingBarItem(item) {
  return (dispatch, getState) => {
    const { activeDomain } = getState().login.user;
    if (item.id === null || item.id === undefined) {
      // Create
      return MeawwApi()
        .auth()
        .then(api => {
          return api.post(`/lp/${activeDomain}/trending-bar`, {
            label: item.label,
            url: item.url,
            sortOrder: item.sortOrder,
            isActive: item.isActive,
          }, (error, data) => {
            if (error) {
              dispatch(setAppMessage(error.message, { type: MessageTypes.ERROR }));
              return Promise.reject(error);
            }
            dispatch(toggleTrendingBarModal(false));
            dispatch(setAppMessage('Trending bar item created', { type: MessageTypes.SUCCESS }));
            dispatch(fetchTrendingBar());
            return Promise.resolve(data);
          });
        });
    } else {
      // Update
      return MeawwApi()
        .auth()
        .then(api => {
          return api.put(`/lp/${activeDomain}/trending-bar/${item.id}`, {
            label: item.label,
            url: item.url,
            sortOrder: item.sortOrder,
            isActive: item.isActive,
          }, (error, data) => {
            if (error) {
              dispatch(setAppMessage(error.message, { type: MessageTypes.ERROR }));
              return Promise.reject(error);
            }
            dispatch(toggleTrendingBarModal(false));
            dispatch(setAppMessage('Trending bar item updated', { type: MessageTypes.SUCCESS }));
            dispatch(fetchTrendingBar());
            return Promise.resolve(data);
          });
        });
    }
  };
}

// ---- Delete
export function deleteTrendingBarItem(itemId) {
  return (dispatch, getState) => {
    const { activeDomain } = getState().login.user;
    return MeawwApi()
      .auth()
      .then(api => {
        return api.delete(`/lp/${activeDomain}/trending-bar/${itemId}`,
          (error, data) => {
            if (error) {
              dispatch(setAppMessage(error.message, { type: MessageTypes.ERROR }));
              return Promise.reject(error);
            }
            dispatch(setAppMessage('Trending bar item deleted', { type: MessageTypes.SUCCESS }));
            dispatch(fetchTrendingBar());
            return Promise.resolve(data);
          });
      });
  };
}

// ---- Modal toggle
export function toggleTrendingBarModal(flag) {
  return { type: 'trendingBar.modal.toggle', flag };
}

// ---- Set modal data for editing
export function setTrendingBarModalData(item) {
  return { type: 'trendingBar.modal.setData', item };
}
